import React, { useEffect, useState } from 'react'
import { Flexbox, Form } from '@/components'
import useAuth from '@/hooks/useAuth'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import resetEmail from '@/services/auth/resetEmail'

function ConfirmEmail({
 email, values, errors, touched, onChangeEmail,
}) {
  const { user, refreshUser } = useAuth()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [timer, setTimer] = useState(60)

  useEffect(() => {
    if (user?.email && !user?.emailVerified) {
      resetEmail.sendEmailVerification(email)
    }
  }, [user, email])

  useEffect(() => {
    if (timer <= 0) return undefined
    const interval = setInterval(() => setTimer((t) => t - 1), 1000)
    return () => clearInterval(interval)
  }, [timer])

  async function verifyToken() {
    if (!email) return
    try {
      setLoading(true)
      await resetEmail.verifyEmail({
        login: email,
        token: values.token,
      })
      await refreshUser()
      toast.success('E-mail verificado com sucesso')
      history.push('/app/settings/account')
    } catch {
      toast.error('Código inválido')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (values.token?.length === 6) {
      verifyToken()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.token])

  async function resendEmail() {
    if (!email) return
    try {
      await resetEmail.sendEmailVerification(email)
      setTimer(60)
      toast.success('E-mail reenviado')
    } catch {
      toast.error('Erro ao reenviar o e-mail')
    }
  }

  return (
    <div className="p-2 text-center">
      <div className="mb-2 pb-2">
        Informe o código de 6 dígitos enviado para
        <div>
          <b>{email}</b>
        </div>
      </div>
      <Flexbox.Columns className="flex-centered">
        <Flexbox.Column className="col-3 col-sm-12">
          <Form.Group>
            <Form.ValidationField name="token">
              {({ field }) => (
                <Form.Input
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...field}
                  maxLength={6}
                  autoFocus
                  className="text-center"
                  placeholder="000000"
                />
              )}
            </Form.ValidationField>

            {errors?.token && touched?.token && (
              <Form.Hint className="text-error mt-1">{errors.token}</Form.Hint>
            )}
          </Form.Group>
        </Flexbox.Column>
      </Flexbox.Columns>
      <button
        type="button"
        className="btn btn-sm btn-link p-0 mt-2 text-gray"
        onClick={onChangeEmail}
      >
        <i className="fas fa-edit mr-1" />
        Editar e-mail
      </button>
      <div className="mt-2">
        {timer > 0 ? (
          <small>
            Reenviar e-mail em <b>{timer}s</b>
          </small>
        ) : (
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={resendEmail}
            disabled={loading}
          >
            <i className="fas fa-redo mr-1" /> Reenviar e-mail
          </button>
        )}
      </div>
    </div>
  )
}

ConfirmEmail.propTypes = {
  email: PropTypes.string.isRequired,
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeEmail: PropTypes.func.isRequired,
}

export default ConfirmEmail
